import styled from "styled-components";
import Phrase from "./components/Phrase";

const Wrapper = styled.div`
  display: flex;
  padding: 4em 2em;
  justify-content: center;
  flex-direction: column;
`;

const Title = styled.h1`
  font-size: 1.5em;
  text-align: center;
  color: #bf4f74;
`;

const Text = styled.h2`
  font-size: 1.2em;
  text-align: center;
  color: #bf4f74;
`;

function App() {
  return (
    <Wrapper>
      <Title>Emoji App</Title>
      <Text>Construye la siguiente frase con emojis</Text>
      <Phrase />
    </Wrapper>
  );
}

export default App;
